import { useEffect } from 'react';
import { engine } from '../hooks/useEngine.ts';
import type { Badge } from '../lib/storage.ts';

interface Props {
  notice: string | null;
  badges: Badge[];
}

export function Toasts({ notice, badges }: Props) {
  useEffect(() => {
    if (!notice) return;
    const id = window.setTimeout(() => engine.dismissNotice(), 5000);
    return () => window.clearTimeout(id);
  }, [notice]);

  useEffect(() => {
    const first = badges[0];
    if (!first) return;
    const id = window.setTimeout(() => engine.dismissBadge(first.id), 5000);
    return () => window.clearTimeout(id);
  }, [badges]);

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex flex-col items-center gap-2 p-4"
      style={{ paddingTop: 'max(1rem, env(safe-area-inset-top))' }}
      role="status"
      aria-live="polite"
    >
      {notice && (
        <button
          type="button"
          onClick={() => engine.dismissNotice()}
          className="glass pointer-events-auto max-w-sm rounded-2xl px-4 py-3 text-center text-sm text-white/85 shadow-2xl"
        >
          {notice}
        </button>
      )}

      {badges.map((badge) => (
        <div
          key={badge.id}
          className="pointer-events-auto flex max-w-sm items-center gap-3 rounded-2xl bg-gradient-to-r from-phidio-600 to-phidio-800 px-4 py-3 text-left shadow-2xl ring-1 ring-white/20"
        >
          <span className="text-2xl">{badge.emoji}</span>
          <span>
            <span className="block text-sm font-semibold">Unlocked · {badge.label}</span>
            <span className="block text-xs text-white/70">{badge.description}</span>
          </span>
        </div>
      ))}
    </div>
  );
}
